module.exports = __webpack_public_path__ + "img/appian.92c46220.png";